<template>
  <div style="height: 100%;overflow: hidden">
    <iframe
    :src="iurl"
    frameborder="0"
    width="100%"
    style="height:100%"
    :name="$store.state.activeTab"
    ></iframe>
    <!-- <div v-html="value">ssssssssssssssssssssssssssss</div> -->
  </div>
</template>
<script>
export default {
  name: "BasicSecond",
  data() {
    return {
      iurl: "",
      // iframeData: "",
      // value: ""
    };
  },
  methods: {
    reloadOrder(data={isWatch:false}){
      const path = this.$router.currentRoute.path
      if(!path) return;
      !data.isWatch && openVueLoading();
      if(path==='/xlcInquiryDetailTemporaryStorage' || path==='/xlcInquiryDetail') this.iurl=`/Xlcinquiry/detail?enquiryId=${this.$route.params.id}&nbBxgsId=&ust=&isnoBxgs=`;
      else if(path==='/xlcmbDetail' || path==='/xlcmbDetailTemporaryStorage')this.iurl = "/xlcmb/detail?enquiryId=" + this.$route.params.id;
      else if(path==="/mb")this.iurl = "/mb/detail?enquiryId=" + this.$route.params.id;
      else if(path==="/createForm" || path==='/createFormTemporaryStorage') this.iurl = "/jninquiry/createForm?enquiryId=" + this.$route.params.id + "&nbBxgsId=" + this.$route.params.nbBxgsId + "&isnoBxgs=" + this.$route.params.isnoBxgs;
      else if(path==="/createPictureForm") this.iurl = "/queryPrice/createPictureForm?enquiryId=" + this.$route.params.id + "&enquiryDTO.picEnquiry=1";
      else if(path==="/jnquotedetail") this.iurl = "/apsapi/jnquote/jnquotedetail?enquiryInfoId=" + this.$route.params.id;
      else if(path==='/factoryOrderDetail') this.iurl='/Order/OrderDetail?orderId='+this.$route.query.orderId;
      else if(path==='/apsCreateDirectSupplyOrder') this.iurl=`/Order/apsCreateDirectSupplyOrder?inquiryId=${this.$route.query.inquiryId}`
      else{
        const pathArr = [
          [
            ['/enquiryRecord'],
            '/Jninquiry/enquiryRecord'
          ],
          [
            ['/salvageCarDetail'],
            `/damagecar/detail?bidId=${this.$route.query.id}`
          ]
        ]
        const result = pathArr.find(i=>i[0].includes(path))
        if(result) this.iurl = result[1]
      }
      
    },
  },
  created() {
    this.reloadOrder();
  },
  watch: {
    $route(to, from) {
      if(to.fullPath===from.fullPath) return;
      this.reloadOrder({isWatch:true})
      var path = this.$router.currentRoute.path;
      if(path==='/xlcInquiryDetailTemporaryStorage' || path==='/xlcInquiryDetail') this.iurl=`/Xlcinquiry/detail?enquiryId=${this.$route.params.id}&nbBxgsId=&ust=&isnoBxgs=`;
      else  if(path==='/xlcmbDetail' || path==='/xlcmbDetailTemporaryStorage')this.iurl = "/xlcmb/detail?enquiryId=" + to.params.id;
      else if (path == "/mb") {
        this.iurl = "/mb/detail?enquiryId=" + to.params.id;
      } else if (path == "/createPictureForm") {
        this.iurl = "/queryPrice/createPictureForm?enquiryId=" + to.params.id + "&enquiryDTO.picEnquiry=1";
      } else if (path == "/createForm" || path==='/createFormTemporaryStorage') {
        console.log("id=======" + to.params.id);
        this.iurl = "/jninquiry/createForm?enquiryId=" + to.params.id + "&nbBxgsId=" + to.params.nbBxgsId + "&isnoBxgs=" + to.params.isnoBxgs;
      }  else if (path == "/jnquotedetail") {
        this.iurl = "/apsapi/jnquote/jnquotedetail?enquiryInfoId=" + this.$route.params.id;
      }
      else if(path==='/factoryOrder') this.iurl='/shop/order/createOrderPage?shopId='+this.$route.params.shopId;
      else if(path==='/factoryOrderDetail') this.iurl='/Order/OrderDetail?orderId='+this.$route.query.orderId;
      else if(path==='/apsCreateDirectSupplyOrder') this.iurl=`/Order/apsCreateDirectSupplyOrder?inquiryId=${this.$route.query.inquiryId}`
    }
  }
};
</script>
